const config = {
  /* 大厅微应用配置 start */
  HALL_APP_NAME: require('../packages/gx-hall/package.json').name,
  HALL_PRO_PUBLIC_PATH: '/child/micro-hall/',
  HALL_DEV_PUBLIC_PATH: '/hall/',
  HALL_ACTIVE_RULE: '/hall',
  HALL_DEV_PORT: '9102',
  /* 大厅微应用配置 end */
  /* 系统管理微应用配置 start */
  SYSTEM_APP_NAME: 'system',
  SYSTEM_PRO_PUBLIC_PATH: '/child/micro-system/',
  SYSTEM_DEV_PUBLIC_PATH: '/system/',
  SYSTEM_ACTIVE_RULE: '/system',
  SYSTEM_DEV_PORT: '9100',
  /* 系统管理微应用配置 end */
}
module.exports = config
